import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { TranslateService } from "@ngx-translate/core";
import * as i0 from "@angular/core";
import * as i1 from "ngx-bootstrap/modal";
import * as i2 from "@ngx-translate/core";
var ModalMessageComponent = /** @class */ (function () {
    //type = '' //to handle 'success' | 'error' | 'info' | 'warning' icons
    function ModalMessageComponent(bsModalRef) {
        this.bsModalRef = bsModalRef;
        this.title = '';
        this.message = '';
    } // Inject BsModalRef
    return ModalMessageComponent;
}());
export { ModalMessageComponent };
var ModalMessageService = /** @class */ (function () {
    function ModalMessageService(modalService, translate) {
        this.modalService = modalService;
        this.translate = translate;
    }
    ModalMessageService.prototype.show = function (message, title, type) {
        if (title === void 0) { title = 'Error'; }
        if (type === void 0) { type = 'error'; }
        if (!message) {
            console.log('ModalMessageService: Message is not set.');
            return;
        }
        if (!title) {
            title = 'Error';
        }
        var initialState = {
            title: this.translate.instant(title),
            message: this.translate.instant(message),
        };
        this.modalService.show(ModalMessageComponent, { initialState: initialState });
    };
    ModalMessageService.ngInjectableDef = i0.defineInjectable({ factory: function ModalMessageService_Factory() { return new ModalMessageService(i0.inject(i1.BsModalService), i0.inject(i2.TranslateService)); }, token: ModalMessageService, providedIn: "root" });
    return ModalMessageService;
}());
export { ModalMessageService };
